import { render } from "./ResetView.vue?vue&type=template&id=730c7fa8&scoped=true"
import script from "./ResetView.vue?vue&type=script&lang=js"
export * from "./ResetView.vue?vue&type=script&lang=js"

import "./ResetView.vue?vue&type=style&index=0&id=730c7fa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730c7fa8"]])

export default __exports__